<script setup lang="ts">
import CheckIcon from '@/assets/icons/CheckIcon.vue';
import BillingCheckoutIllustrationPanel from './BillingCheckoutIllustrationPanel.vue';

withDefaults(
  defineProps<{
    illustrationSrc?: string;
    title: string;
    description: string;
    body?: string;
    preserveDescriptionWhitespace?: boolean;
  }>(),
  {
    illustrationSrc: '/assets/billing/invoice-success-illustration.png',
    body: undefined,
    preserveDescriptionWhitespace: false,
  },
);
</script>

<template>
  <div class="flex h-full min-h-0 overflow-hidden bg-surface-primary max-md:flex-col">
    <BillingCheckoutIllustrationPanel :src="illustrationSrc" />

    <div class="flex h-full min-w-0 flex-1 flex-col bg-surface-primary px-xxl py-xxl max-md:p-lg max-md:pt-xxl">
      <div class="min-h-0 flex-1 overflow-y-auto">
        <div class="flex h-full min-h-[420px] flex-col gap-xl max-md:min-h-0 max-md:gap-lg">
          <span
            class="flex size-[72px] shrink-0 items-center justify-center rounded-full bg-success text-white max-md:size-[56px]"
          >
            <CheckIcon class="size-[48px] max-md:size-[36px]" />
          </span>

          <div class="flex max-w-[420px] flex-col text-primary">
            <h1 class="text-title font-medium text-primary max-md:text-heading">
              {{ title }}
            </h1>
            <p
              class="text-title font-normal text-primary max-md:text-body"
              :class="preserveDescriptionWhitespace && 'whitespace-pre-line'"
            >
              {{ description }}
            </p>
          </div>

          <p v-if="body" class="min-h-0 max-w-[420px] flex-1 text-body text-primary">
            {{ body }}
          </p>
        </div>
      </div>

      <div class="flex shrink-0 items-center justify-end gap-md pt-md max-md:pb-mobile-safe-bottom-lg">
        <slot name="footer" />
      </div>
    </div>
  </div>
</template>
